module.exports = __webpack_public_path__ + "assets/img/drape_selected.32739f81.svg";